import React, { useState, useEffect, useRef } from 'react'
import { Modal, Form } from 'react-bootstrap'
import { CheckBox } from 'devextreme-react/check-box'
import { toast } from 'react-toastify'
import { useParams } from '../../../Providers/ParamsProvider'
import { noAutofillProps } from '../Config/noAutofillProps'

const EMPTY_ELEMENT = { name: '', reDirectLink: '', isReDirectLinkDirectToEHandel: false }

const AddNavBarElementModal = ({ show, onHide, onAdded }) => {
    const { handleAddNavBarItem } = useParams()
    const [navBarElement, setNavBarElement] = useState(EMPTY_ELEMENT)
    const [errorText, setErrorText] = useState(null)
    const firstInputRef = useRef(null)

    useEffect(() => {
        if (!show) {
            setNavBarElement(EMPTY_ELEMENT)
            setErrorText(null)
        }
    }, [show])

    const handelAddNewElement = async () => {
        if (!validateData()) {
            return
        }
        const success = await handleAddNavBarItem(navBarElement)
        if (success) {
            toast.success('Dodano nową pozycję.')
            setNavBarElement(EMPTY_ELEMENT)
            setErrorText(null)
            onAdded?.()
            onHide()
        } else {
            toast.error('Błąd podczas dodawania pozycji!')
        }
    }

    const validateData = () => {
        if (!navBarElement.name.trim()) {
            setErrorText('Uzupełnij nazwe!')
            return false
        }
        if (!navBarElement.reDirectLink.trim()) {
            setErrorText('Uzupełnij link przekierowania!')
            return false
        }
        return true
    }

    return (<Modal size='lg' show={show} onHide={onHide} centered onEntered={() => firstInputRef.current?.focus()}>
        <Modal.Header closeButton>
            <Modal.Title>Dodawanie nowej pozycji</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="row mt-2 align-items-center">
                <div className="col-2"><span>Nazwa:</span></div>
                <div className="col">
                    <Form.Control
                        ref={firstInputRef}
                        name='name'
                        {...noAutofillProps}
                        value={navBarElement.name}
                        maxLength={100}
                        onChange={(e) => setNavBarElement({ ...navBarElement, name: e.target.value })}
                    />
                </div>
                <div className="col-auto">
                    <span className='error-text-color'>*</span>
                </div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-2"><span>Link przekierowania:</span></div>
                <div className="col">
                    <Form.Control
                        name='reDirectLink'
                        {...noAutofillProps}
                        value={navBarElement.reDirectLink}
                        maxLength={1000}
                        onChange={(e) => setNavBarElement({ ...navBarElement, reDirectLink: e.target.value })}
                    />
                </div>
                <div className="col-auto">
                    <span className='error-text-color'>*</span>
                </div>
            </div>
            <div className="row mt-2 align-items-center">
                <div className="col-auto"><span>Wewnątrz platformy eHandel:</span></div>
                <div className="col">
                    <CheckBox
                        className="custom-checkbox"
                        value={navBarElement.isReDirectLinkDirectToEHandel}
                        onValueChanged={(e) => setNavBarElement({ ...navBarElement, isReDirectLinkDirectToEHandel: e.value })}
                    />
                </div>
            </div>
            <div className={`d-flex justify-content-center mt-3 mb-3`}>
                <span className='error-text-color'>{errorText}</span>
            </div>
            <div className="d-flex flex justify-content-end  mt-4">
                <button className='btn-app-primary me-3' onClick={() => handelAddNewElement()}>Dodaj</button>
                <button className='btn-app-secondary' onClick={() => onHide(null)}>Anuluj</button>
            </div>
        </Modal.Body>
    </Modal>)
}

export default AddNavBarElementModal
